module.exports = __webpack_public_path__ + "static/img/8.0396063.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/realisations/fletrePortail/8.png
// module id = CDs1
// module chunks = 0